import type { ReactNode } from 'react'
import {
  Dialog,
  Modal,
  ModalOverlay,
} from 'react-aria-components'

import { cn } from '@/shared/lib/cn'

interface DrawerProps {
  isOpen: boolean

  onOpenChange: (
    isOpen: boolean,
  ) => void

  ariaLabel: string
  children: ReactNode
  className?: string
}

export function Drawer({
  isOpen,
  onOpenChange,
  ariaLabel,
  children,
  className,
}: DrawerProps) {
  return (
    <ModalOverlay
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      isDismissable
      className={[
        'fixed inset-0 z-50',
        'bg-slate-950/50 backdrop-blur-sm',
        'lg:hidden',
      ].join(' ')}
    >
      <Modal
        className={cn(
          [
            'h-(--visual-viewport-height)',
            'w-[min(18rem,88vw)]',
            'bg-(--color-sidebar)',
            'shadow-2xl outline-none',
          ],
          className,
        )}
      >
        <Dialog
          aria-label={ariaLabel}
          className="h-full outline-none"
        >
          {children}
        </Dialog>
      </Modal>
    </ModalOverlay>
  )
}